import {env} from '@/matic/config/env';

const DEV_RELAY_FORWARDING_ADDRESS_BY_TENANT_ID = new Map([
  ['12345678-1234-5678-9abc-12345678901a', 'alpha@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-12345678901b', 'beta@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-123456789010', 'dev@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-11111111111c', 'revstar@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-22222222222c', 'matic-eng@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-22222222222a', 'matic-gtm@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-22222222222b', 'joe-phd@relay-dev.matic.systems'],
  ['12345678-1234-5678-9abc-33333333333a', 'aes@relay-dev.matic.systems'],
]);

const PROD_RELAY_FORWARDING_ADDRESS_BY_TENANT_ID = new Map([
  ['12345678-1234-5678-9abc-123456789010', 'test@relay.matic.systems'],
  ['560fe024-4e5f-4867-8f0e-ac4ec783d275', 'poba@relay.matic.systems'],
  ['b2cfe3d2-7edb-498e-8bcb-00d6d0cf004f', 'techcomm@relay.matic.systems'],
  ['23696e35-50d0-4979-a5de-95fe5ed16c0e', 'salient@relay.matic.systems'],
  ['e11962ea-c9ad-4465-b4ce-64bebdfd4ca4', 'bemis@relay.matic.systems'],
  ['78b9eb7f-7ba4-4396-a0a8-f10f1ae09fc0', 'chromalloy@relay.matic.systems'],
  ['c6fc8056-6a2d-4d55-ac53-bc5cf8ea4f5c', 'newwavedesign@relay.matic.systems'],
  ['38b85355-6011-4791-aeb8-8ac498970422', 'aes@relay.matic.systems'],
]);

export function getRelayForwardingAddress(
  tenantId: string
): string | undefined {
  // Local-cloud tenants are created locally and their UUIDs vary by developer.
  // They share the development Relay mailbox, so don't require each ephemeral
  // local tenant id to be added to the static dev map.
  if (env.APP_ENV === 'local-cloud') {
    return 'dev@relay-dev.matic.systems';
  }

  const addresses =
    env.APP_ENV === 'prod'
      ? PROD_RELAY_FORWARDING_ADDRESS_BY_TENANT_ID
      : DEV_RELAY_FORWARDING_ADDRESS_BY_TENANT_ID;

  return addresses.get(tenantId);
}
